import * as React from "react";
import { Box, Preloader } from "@origin-digital/ods-core";

export const Loader = () => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    style={{ height: "100vh" }}
  >
    <Preloader {...{ role: "status", "aria-label": "loading" }} size="large" />
  </Box>
);
